var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert"},[_c('img',{attrs:{"src":"/static/images/new/real_alert.png","alt":""}}),(_vm.msg)?_c('Marquee',{attrs:{"delay":0,"speed":50,"content":_vm.msg}},[_vm._v(_vm._s(_vm.msg))]):_c('div',[_vm._v("暂无预警")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }